"use strict";
'kiwi public';

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.create = create;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/defineProperty"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _lodash = _interopRequireDefault(require("lodash"));

var _strftime = _interopRequireDefault(require("strftime"));

var _ircFramework = _interopRequireDefault(require("irc-framework"));

var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));

var IrcdDiffs = _interopRequireWildcard(require("@/helpers/IrcdDiffs"));

var _TypingMiddleware = _interopRequireDefault(require("./TypingMiddleware"));

var _ChathistoryMiddleware = _interopRequireDefault(require("./ChathistoryMiddleware"));

var ServerConnection = _interopRequireWildcard(require("./ServerConnection"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context26; (0, _forEach.default)(_context26 = ownKeys(Object(source), true)).call(_context26, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context27; (0, _forEach.default)(_context27 = ownKeys(Object(source))).call(_context27, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function create(state, network) {
  var networkid = network.id;
  var clientOpts = {
    host: network.connection.server,
    port: network.connection.port,
    tls: network.connection.tls,
    path: network.connection.path,
    password: network.connection.password,
    account: {
      account: network.connection.nick,
      password: network.password
    },
    nick: network.connection.nick,
    username: network.username || network.connection.nick,
    gecos: network.gecos || 'https://kiwiirc.com/',
    version: null,
    auto_reconnect: false,
    encoding: network.connection.encoding,
    message_max_length: 350
  };
  var ircClient = new _ircFramework.default.Client(clientOpts);
  ircClient.requestCap('znc.in/self-message'); // Current version of irc-framework only support draft/message-tags-0.2
  // TODO: Removee this once irc-framework has been updated

  ircClient.requestCap('message-tags');
  ircClient.use((0, _ChathistoryMiddleware.default)());
  ircClient.use(clientMiddleware(state, network));
  ircClient.use((0, _TypingMiddleware.default)()); // Overload the connect() function to make sure we are connecting with the
  // most recent connection details from the state

  var originalIrcClientConnect = ircClient.connect;

  ircClient.connect = function connect() {
    // Set some defaults if we don't have eveything
    if (!network.connection.nick) {
      network.connection.nick = 'Guest' + Math.floor(Math.random() * 100);
    }

    ircClient.options.host = network.connection.server;
    ircClient.options.port = network.connection.port;
    ircClient.options.tls = network.connection.tls;
    ircClient.options.path = network.connection.path;
    ircClient.options.password = network.connection.password;

    if (network.password) {
      ircClient.options.account = {
        account: network.connection.nick,
        password: network.password
      };
    } else {
      // No password so give an empty account config. This forces irc-framework to keep
      // the server password (options.password) separate from SASL
      ircClient.options.account = {};
    }

    ircClient.options.nick = network.connection.nick;
    ircClient.options.username = network.username || network.connection.nick;
    ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
    ircClient.options.encoding = network.connection.encoding;
    ircClient.options.auto_reconnect = !!state.setting('autoReconnect'); // Apply any irc-fw options specified in kiwiirc config

    var configOptions = state.setting('ircFramework');

    if (configOptions) {
      (0, _assign.default)(ircClient.options, configOptions);
    }

    var eventObj = {
      network: network,
      transport: null
    };
    state.$emit('network.connecting', eventObj);

    if (eventObj.transport) {
      // A plugin might use its own transport of some kind
      ircClient.options.transport = eventObj.transport;
    } else if (!network.connection.direct) {
      // A direct connection uses a websocket to connect (note: some browsers limit
      // the number of connections to the same host!).
      // A non-direct connection will connect via the configured kiwi server using
      // with our own irc-framework compatible transport.
      ircClient.options.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
    } else {
      // Use the irc-framework default transport
      ircClient.options.transport = undefined;
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    originalIrcClientConnect.apply(ircClient, args);
  }; // Overload the raw() function so that we can emit outgoing IRC messages to plugins


  var originalIrcClientRaw = ircClient.raw;

  ircClient.raw = function raw() {
    var message = null;

    if ((arguments.length <= 0 ? undefined : arguments[0]) instanceof _ircFramework.default.Message) {
      message = arguments.length <= 0 ? undefined : arguments[0];
    } else {
      var rawString = ircClient.rawString.apply(ircClient, arguments);
      message = _ircFramework.default.ircLineParser(rawString);
    }

    var eventObj = {
      network: network,
      message: message,
      handled: false
    };
    state.$emit('ircout', eventObj);

    if (!eventObj.handled) {
      originalIrcClientRaw.apply(ircClient, [message]);
    }
  };

  ircClient.on('raw', function (event) {
    if (!network.setting('show_raw') && !state.setting('showRaw')) {
      return;
    }

    var buffer = state.getOrAddBufferByName(networkid, '*raw');
    state.addMessage(buffer, {
      time: (0, _now.default)(),
      nick: '',
      message: (event.from_server ? '[S] ' : '[C] ') + event.line
    });
  });
  ircClient.on('typing', function (event) {
    var user = state.getUser(network.id, event.nick);

    if (user) {
      user.typingStatus(event.target, event.status);
    }
  });
  return ircClient;
}

function clientMiddleware(state, network) {
  var networkid = network.id; // eslint-disable-next-line

  var numConnects = 0;
  var isRegistered = false;
  return function middlewareFn(client, rawEvents, parsedEvents) {
    parsedEvents.use(parsedEventsHandler);
    rawEvents.use(rawEventsHandler);
    client.on('connecting', function () {
      network.state_error = '';
      network.state = 'connecting';
      network.last_error = '';
      network.last_error_numeric = 0;
    });
    client.on('connected', function () {
      var _context;

      network.state_error = '';
      network.state = 'connected';
      (0, _forEach.default)(_context = network.buffers).call(_context, function (buffer) {
        if (!buffer) {
          return;
        }

        var messageBody = TextFormatting.formatText('network_connected', {
          text: TextFormatting.t('connected')
        });
        state.addMessage(buffer, {
          time: (0, _now.default)(),
          nick: '',
          message: messageBody,
          type: 'connection',
          type_extra: 'connected'
        });
      });
    });
    client.on('socket close', function (err) {
      var _context2;

      isRegistered = false;
      network.state = 'disconnected';
      network.state_error = err || '';
      (0, _forEach.default)(_context2 = network.buffers).call(_context2, function (buffer) {
        if (!buffer) {
          return;
        }

        buffer.joined = false;
        buffer.clearUsers();
        var messageBody = TextFormatting.formatText('network_disconnected', {
          text: TextFormatting.t('disconnected')
        });
        state.addMessage(buffer, {
          time: (0, _now.default)(),
          nick: '',
          message: messageBody,
          type: 'connection',
          type_extra: 'disconnected'
        });
      });
    });
  };

  function rawEventsHandler(command, event, rawLine, client, next) {
    // Allow plugins to override raw IRC events
    var eventObj = _objectSpread({}, event, {
      raw: rawLine,
      handled: false
    });

    state.$emit('irc.raw', command, eventObj, network);

    if (eventObj.handled) {
      return;
    }

    state.$emit('irc.raw.' + command, command, eventObj, network);

    if (eventObj.handled) {
      return;
    }

    if (command === '002') {
      // Your host is server.example.net, running version InspIRCd-2.0
      var param = event.params[1] || '';
      var m = param.match(/running version (.*)$/);
      network.ircd = m ? m[1] : '';
    } // SASL failed auth


    if (command === '904') {
      if (!network.state !== 'connected') {
        network.last_error = 'Invalid login';

        if (state.setting('disconnectOnSaslFail')) {
          network.ircClient.connection.end();
        }
      }

      var serverBuffer = network.serverBuffer();
      state.addMessage(serverBuffer, {
        time: (0, _now.default)(),
        nick: '*',
        message: 'Invalid login'
      });
    }

    if (command === 'CAP' && network.setting('show_raw_caps')) {
      var _context3;

      var params = (0, _toConsumableArray2.default)(event.params);

      if ((0, _indexOf.default)(_context3 = params[params.length - 1]).call(_context3, ' ') > -1) {
        params[params.length - 1] = ':' + params[params.length - 1];
      }

      var buffer = network.serverBuffer();
      state.addMessage(buffer, {
        time: (0, _now.default)(),
        nick: '',
        message: event.command + ' ' + params.join(' ')
      });
    }

    next();
  }

  function parsedEventsHandler(command, event, client, next) {
    // Trigger this event through the state object first. If it's been handled
    // somewhere else then we ignore it.
    var ircEventObj = {
      handled: false
    };
    state.$emit('irc.' + command, event, network, ircEventObj);

    if (ircEventObj.handled) {
      next();
      return;
    } // Ignore any of the control messages. They're transport related to kiwi internals


    if (event && event.command === 'CONTROL') {
      next();
      return;
    } // If there is a time difference between this client and the server, convert it
    // to match our local time so it makes sense to the user


    var eventTime = event && event.time ? network.ircClient.network.timeToLocal(event.time) : (0, _now.default)();
    var serverTime = event && event.time || 0;

    if (command === 'channel_redirect') {
      var b = network.bufferByName(event.from);

      if (b) {
        (0, _flags.default)(b).redirect_to = event.to;
      }
    }

    if (command === 'registered') {
      isRegistered = true;
      network.nick = event.nick;
      state.addUser(networkid, {
        nick: event.nick,
        username: client.user.username
      });
      var serverBuffer = network.serverBuffer();
      state.addMessage(serverBuffer, {
        time: (0, _now.default)(),
        nick: '',
        message: TextFormatting.t('connected_to', {
          network: client.network.name
        })
      }); // Get some extra info about ourselves

      client.raw('WHO ' + event.nick);

      if (network.auto_commands) {
        var _context4;

        (0, _forEach.default)(_context4 = network.auto_commands.split('\n')).call(_context4, function (line) {
          state.$emit('input.raw', line[0] === '/' ? line : "/".concat(line));
        });
      } // Join our channels
      // If under bouncer mode, the bouncer will send the channels were joined to instead.


      if (!network.connection.bncnetid) {
        var _context5;

        (0, _forEach.default)(_context5 = network.buffers).call(_context5, function (buffer) {
          if (buffer.isChannel() && buffer.enabled) {
            client.join(buffer.name, buffer.key);
          }
        });
      }

      numConnects++;
    }

    if (command === 'server options') {
      // If the network name has changed from the irc-framework default, update ours
      // Also if it isn't a BNC network as the name is then derived from the BNC info instead
      if (client.network.name !== 'Network' && !network.connection.bncnetid) {
        network.name = client.network.name;
      }
    } // Show unhandled data from the server in the servers tab


    if (command === 'unknown command') {
      if (event.command === '486') {
        // You must log in with services to message this user
        var targetNick = event.params[1];
        var buffer = state.getOrAddBufferByName(network.id, targetNick);
        state.addMessage(buffer, {
          time: (0, _now.default)(),
          nick: '*',
          message: event.params[2],
          type: 'error'
        });
      } else {
        var _buffer = network.serverBuffer();

        var message = ''; // Only show non-numeric commands

        if (!event.command.match(/^\d+$/)) {
          message += event.command + ' ';
        }

        var containsNick = event.params[0] === network.ircClient.user.nick;
        var isChannelMessage = network.isChannelName(event.params[1]); // Strip out the nick if it's the first params (many commands include this)

        if (containsNick && isChannelMessage) {
          var _context6;

          var channelBuffer = network.bufferByName(event.params[1]);

          if (channelBuffer) {
            _buffer = channelBuffer;
          }

          message += (0, _slice.default)(_context6 = event.params).call(_context6, 2).join(', ');
        } else if (containsNick) {
          var _context7;

          message += (0, _slice.default)(_context7 = event.params).call(_context7, 1).join(', ');
        } else {
          message += event.params.join(', ');
        }

        state.addMessage(_buffer, {
          nick: '',
          message: message
        });
      }
    }

    if (command === 'message') {
      var isPrivateMessage = false;
      var bufferName = event.from_server ? '*' : event.target; // PMs should go to a buffer with the name of the other user

      if (!event.from_server && event.target === client.user.nick) {
        isPrivateMessage = true;
        bufferName = event.nick;
      } // Chanserv sometimes PMs messages about a channel on join in the format of
      // [#channel] welcome!
      // Redirect these to #channel


      if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
        var _context8;

        bufferName = event.message.substr(1, (0, _indexOf.default)(_context8 = event.message).call(_context8, ']') - 1);
      } // Notices from somewhere when we don't have an existing buffer for them should go into
      // the server tab. ie. notices from servers


      if (event.type === 'notice') {
        var existingBuffer = state.getBufferByName(networkid, bufferName);
        var noticeActiveBuffer = state.setting('noticeActiveBuffer');
        var activeBuffer = state.getActiveBuffer();
        var hasActiveBuffer = activeBuffer && activeBuffer.networkid === networkid; // If we don't have a buffer for this notice sender, either show it in our active
        // buffer or the server buffer

        if (!existingBuffer) {
          if (noticeActiveBuffer && hasActiveBuffer) {
            bufferName = activeBuffer.name;
          } else {
            bufferName = '*';
          }
        }
      }

      var PM_BLOCK_BLOCKED = false; // const PM_BLOCK_NOT_BLOCKED = true;

      var PM_BLOCK_REQUIRES_CHECK = null;
      var pmBlock = network.isNickExemptFromPmBlocks(event.nick);
      var blockNewPms = state.setting('buffers.block_pms');

      var _buffer2 = state.getBufferByName(networkid, bufferName);

      var textFormatType = 'privmsg';

      if (event.type === 'action') {
        textFormatType = 'action';
      } else if (event.type === 'notice') {
        textFormatType = 'notice';
      }

      var messageBody = TextFormatting.formatText(textFormatType, {
        nick: event.nick,
        username: event.ident,
        host: event.hostname,
        text: event.message
      });
      var _message = {
        time: eventTime,
        server_time: serverTime,
        nick: event.nick,
        message: messageBody,
        type: event.type,
        tags: event.tags || {}
      }; // If this is a new PM and the sending user is not exempt from blocks, ignore it

      if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_BLOCKED) {
        return;
      } // If we need to manually check if this user is blocked..
      // PM_BLOCK_REQUIRES_CHECK means we should whois the user to get their oper status. We
      // allways allow messages from opers.


      if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_REQUIRES_CHECK) {
        // if the nick is in pendingPms it has already issued a whois request
        var awaitingWhois = !!(0, _find.default)(_lodash.default).call(_lodash.default, network.pendingPms, {
          nick: event.nick
        });
        network.pendingPms.push({
          bufferName: bufferName,
          message: _message
        }); // Don't send another whois if we are already awaiting another

        if (awaitingWhois) {
          return;
        }

        network.ircClient.whois(event.nick, event.nick, function (whoisData) {
          var _context9;

          (0, _forEach.default)(_context9 = network.pendingPms).call(_context9, function (pm, idx, obj) {
            var nickLower = pm.message.nick.toLowerCase();

            if (nickLower === whoisData.nick.toLowerCase()) {
              if (whoisData.operator) {
                _buffer2 = state.getOrAddBufferByName(network.id, pm.bufferName);
                state.addMessage(_buffer2, pm.message);
              }

              (0, _splice.default)(obj).call(obj, idx, 1);
            }
          });
        });
        return;
      } // Make sure we have a buffer for our message


      if (!_buffer2) {
        _buffer2 = state.getOrAddBufferByName(networkid, bufferName);
      }

      state.addMessage(_buffer2, _message);
    }

    if (command === 'wallops') {
      var _buffer3 = state.getOrAddBufferByName(networkid, '*');

      var _messageBody = TextFormatting.formatText('wallops', {
        text: event.message
      });

      state.addMessage(_buffer3, {
        time: eventTime,
        server_time: serverTime,
        nick: event.nick,
        message: _messageBody,
        type: 'wallops'
      });
    }

    if (command === 'join') {
      // If we have any buffers marked as being redirected to this new channel, update
      // that buffer instead of creating a new one
      if (event.nick === client.user.nick) {
        var _context10;

        (0, _forEach.default)(_context10 = network.buffers).call(_context10, function (b) {
          if (((0, _flags.default)(b).redirect_to || '').toLowerCase() === event.channel.toLowerCase()) {
            state.$delete((0, _flags.default)(b), 'redirect_to');
            b.rename(event.channel);
          }
        });
      }

      var _buffer4 = state.getOrAddBufferByName(networkid, event.channel); // The case does not match, update buffer.name to the casing sent by the server


      if (_buffer4.name !== event.channel) {
        _buffer4.rename(event.channel);
      }

      state.addUserToBuffer(_buffer4, {
        nick: event.nick,
        username: event.ident,
        host: event.hostname,
        realname: event.gecos,
        account: event.account || ''
      });

      if (event.nick === client.user.nick) {
        _buffer4.enabled = true;
        _buffer4.joined = true;
        (0, _flags.default)(_buffer4).channel_badkey = false;
        network.ircClient.raw('MODE', event.channel);
        network.ircClient.who(event.channel);
      }

      var nick = _buffer4.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

      var _messageBody2 = TextFormatting.formatAndT('channel_join', null, 'has_joined', {
        nick: nick
      });

      state.addMessage(_buffer4, {
        time: (0, _now.default)(),
        nick: event.nick,
        message: _messageBody2,
        type: 'traffic',
        type_extra: 'join'
      });
    }

    if (command === 'kick') {
      var _buffer5 = state.getOrAddBufferByName(networkid, event.channel);

      state.removeUserFromBuffer(_buffer5, event.kicked);
      var _messageBody3 = '';

      if (event.kicked === client.user.nick) {
        _buffer5.joined = false;

        _buffer5.clearUsers();

        _messageBody3 = TextFormatting.formatAndT('channel_selfkick', {
          reason: event.message
        }, 'kicked_you_from', {
          nick: TextFormatting.formatUser(event),
          channel: event.channel
        });
      } else {
        _messageBody3 = TextFormatting.formatAndT('channel_kicked', {
          reason: event.message
        }, 'was_kicked_from', {
          nick: event.kicked,
          channel: event.channel,
          chanop: TextFormatting.formatUser(event.nick)
        });
      }

      state.addMessage(_buffer5, {
        time: (0, _now.default)(),
        nick: event.nick,
        message: _messageBody3,
        type: 'traffic',
        type_extra: 'kick'
      });
    }

    if (command === 'part') {
      var _buffer6 = state.getBufferByName(networkid, event.channel);

      if (!_buffer6) {
        return;
      }

      state.removeUserFromBuffer(_buffer6, event.nick);

      if (event.nick === client.user.nick) {
        _buffer6.joined = false;
        _buffer6.enabled = false;

        _buffer6.clearUsers();
      } // Remove the user from network state if no remaining common channels


      var remainingBuffers = state.getBuffersWithUser(networkid, event.nick);

      if (remainingBuffers.length === 0) {
        state.removeUser(networkid, {
          nick: event.nick
        });
      }

      var _nick = _buffer6.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

      var _messageBody4 = TextFormatting.formatAndT('channel_part', {
        reason: event.message
      }, 'has_left', {
        nick: _nick
      });

      state.addMessage(_buffer6, {
        time: (0, _now.default)(),
        nick: event.nick,
        message: _messageBody4,
        type: 'traffic',
        type_extra: 'part'
      });
    }

    if (command === 'quit') {
      var buffers = state.getBuffersWithUser(networkid, event.nick);
      (0, _forEach.default)(buffers).call(buffers, function (buffer) {
        if (!buffer) {
          return;
        }

        if (event.nick === client.user.nick) {
          buffer.joined = false;
          buffer.clearUsers();
        }

        var nick = buffer.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);
        var messageBody = TextFormatting.formatAndT('channel_quit', {
          reason: event.message
        }, 'has_left', {
          nick: nick
        });
        state.addMessage(buffer, {
          time: (0, _now.default)(),
          nick: event.nick,
          message: messageBody,
          type: 'traffic',
          type_extra: 'quit'
        });
      });
      state.removeUser(networkid, {
        nick: event.nick
      });
    }

    if (command === 'invite') {
      var _buffer7 = network.serverBuffer();

      state.addMessage(_buffer7, {
        nick: '*',
        message: TextFormatting.t('invited_you', {
          nick: event.nick,
          channel: event.channel
        })
      });
    }

    if (command === 'account') {
      state.addUser(networkid, {
        nick: event.nick,
        account: event.account || ''
      });
    }

    if (command === 'whois') {
      var _context11;

      var obj = {
        nick: event.nick,
        host: event.hostname,
        username: event.ident,
        away: event.away || '',
        realname: event.real_name,
        hasWhois: true
      }; // Some other optional bits of info

      (0, _forEach.default)(_context11 = ['actual_host', 'helpop', 'bot', 'server', 'server_info', 'operator', 'channels', 'modes', 'idle', 'logon', 'registered_nick', 'account', 'secure', 'special']).call(_context11, function (prop) {
        if (typeof event[prop] !== 'undefined') {
          obj[prop] = event[prop];
        }
      });
      state.addUser(networkid, obj);
    }

    if (command === 'away') {
      state.addUser(networkid, {
        nick: event.nick,
        away: event.message || ''
      });

      var _buffer8 = state.getActiveBuffer();

      if (_buffer8 && event.nick === network.nick) {
        network.away = 'away';
        state.addMessage(_buffer8, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          type: 'presence',
          message: event.message
        });
      }
    }

    if (command === 'back') {
      state.addUser(networkid, {
        nick: event.nick,
        away: ''
      });

      var _buffer9 = state.getActiveBuffer();

      if (_buffer9 && event.nick === network.nick) {
        network.away = '';
        state.addMessage(_buffer9, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          type: 'presence',
          message: event.message
        });
      }
    }

    if (command === 'wholist') {
      state.usersTransaction(networkid, function (users) {
        var _context12;

        (0, _forEach.default)(_context12 = event.users).call(_context12, function (eventUser) {
          var _context13;

          var userObj = {
            nick: eventUser.nick,
            host: eventUser.hostname || undefined,
            username: eventUser.ident || undefined,
            away: eventUser.away ? 'Away' : '',
            realname: eventUser.real_name,
            account: eventUser.account || undefined
          };
          var user = state.addUser(networkid, userObj, users);

          if (!user) {
            // Should never happen as this network should always exist
            return;
          }

          var buffer = network.bufferByName(eventUser.channel);

          if (!buffer || !user.buffers[buffer.id]) {
            return;
          } // Add all the user channel modes


          var modes = user.buffers[buffer.id].modes;
          (0, _forEach.default)(_context13 = eventUser.channel_modes).call(_context13, function (mode) {
            if ((0, _indexOf.default)(modes).call(modes, mode) === -1) {
              modes.push(mode);
            }
          });
        });
      });
    }

    if (command === 'channel list start') {
      network.channel_list_cache = [];
      network.channel_list_state = 'updating';
    }

    if (command === 'channel list') {
      var _context14;

      network.channel_list_state = 'updating'; // Filter private channels from the channel list

      var filteredEvent = (0, _filter.default)(_lodash.default).call(_lodash.default, event, function (o) {
        return o.channel !== '*';
      }); // Store the channels in channel_list_cache before moving it all to
      // channel_list at the end. This gives a huge performance boost since
      // it doesn't need to be all reactive for every update

      network.channel_list_cache = (0, _concat.default)(_context14 = network.channel_list_cache || []).call(_context14, filteredEvent);
    }

    if (command === 'channel list end') {
      network.channel_list = network.channel_list_cache || [];
      network.channel_list_state = 'updated';
      delete network.channel_list_cache;
    }

    if (command === 'motd') {
      var _buffer10 = network.serverBuffer();

      var _messageBody5 = TextFormatting.formatText('motd', {
        text: event.motd
      });

      state.addMessage(_buffer10, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody5,
        type: 'motd'
      });
    }

    if (command === 'nick in use' && !client.connection.registered) {
      var _context15;

      var newNick = client.user.nick + rand(1, 100);

      var _messageBody6 = TextFormatting.formatAndT('nickname_alreadyinuse', null, 'nick_in_use_retrying', {
        nick: client.user.nick,
        newnick: newNick
      });

      (0, _forEach.default)(_context15 = network.buffers).call(_context15, function (b) {
        state.addMessage(b, {
          time: (0, _now.default)(),
          nick: '',
          message: _messageBody6,
          type: 'error'
        });
      });
      client.changeNick(newNick);
    }

    if (command === 'nick in use' && client.connection.registered) {
      var _buffer11 = state.getActiveBuffer();

      _buffer11 && state.addMessage(_buffer11, {
        time: (0, _now.default)(),
        nick: '',
        type: 'error',
        message: "The nickname '".concat(event.nick, "' is already in use!")
      });
    }

    if (command === 'nick') {
      if (event.nick === client.user.nick) {
        network.nick = event.new_nick;
      }

      state.changeUserNick(networkid, event.nick, event.new_nick);

      var _messageBody7 = TextFormatting.formatAndT('nick_changed', null, 'now_known_as', {
        nick: event.nick,
        newnick: event.new_nick
      });

      var _buffers = state.getBuffersWithUser(networkid, event.new_nick);

      (0, _forEach.default)(_buffers).call(_buffers, function (buffer) {
        state.addMessage(buffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody7,
          type: 'nick'
        });
      });
    }

    if (command === 'userlist') {
      var _context16, _context17;

      var _buffer12 = state.getOrAddBufferByName(networkid, event.channel);

      var hadExistingUsers = (0, _filter.default)(_context16 = (0, _keys.default)(_buffer12.users)).call(_context16, function (u) {
        return u !== network.ircClient.user.nick;
      }).length > 0;
      var users = [];
      (0, _forEach.default)(_context17 = event.users).call(_context17, function (user) {
        users.push({
          user: {
            nick: user.nick,
            username: user.ident,
            hostname: user.hostname
          },
          modes: user.modes
        });
      });
      state.addMultipleUsersToBuffer(_buffer12, users);

      if (!hadExistingUsers && network.ircClient.chathistory.isSupported()) {
        var correctBuffer = _buffer12.isChannel() || _buffer12.isQuery(); // TODO: If this is a reconnect (numConnects > 1) then paginate backwards
        //       until we reach our last message.
        //       OR
        //       Add a marker at the gap between this new chathistory block starts and when
        //       the existing messages end so that we can add a "load missing messages"
        //       button there or have it auto request them when it scrolls into view


        if (correctBuffer) {
          _buffer12.requestLatestScrollback();
        }
      }
    }

    if (command === 'channel info') {
      var _buffer13 = network.bufferByName(event.channel);

      if (!_buffer13) {
        return;
      }

      if (event.modes) {
        var _context18;

        var modeStrs = [];
        (0, _forEach.default)(_context18 = event.modes).call(_context18, function (mode) {
          var adding = mode.mode[0] === '+';
          var modeChar = mode.mode.substr(1);

          if (adding) {
            state.$set(_buffer13.modes, modeChar, mode.param);
          } else if (!adding) {
            state.$delete(_buffer13.modes, modeChar);
          }

          modeStrs.push(mode.mode + (mode.param ? ' ' + mode.param : ''));
        });

        if ((0, _flags.default)(_buffer13).requested_modes) {
          state.addMessage(_buffer13, {
            time: eventTime,
            server_time: serverTime,
            nick: '*',
            message: _buffer13.name + ' ' + modeStrs.join(', ')
          });
        }
      }

      if (event.created_at) {
        _buffer13.created_at = new Date(event.created_at * 1000);
      }

      if (event.created_at && (0, _flags.default)(_buffer13).requested_modes) {
        var tFormat = _buffer13.setting('timestamp_full_format');

        var timeCreated = tFormat ? (0, _strftime.default)(tFormat, new Date(event.created_at * 1000)) : new Date(event.created_at * 1000).toLocaleString();
        state.addMessage(_buffer13, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          message: _buffer13.name + ' ' + timeCreated
        });
      }
    }

    if (command === 'mode') {
      var _buffer14 = network.bufferByName(event.target);

      var _modeStrs = {};

      if (_buffer14) {
        var _context19;

        // Join all the same mode changes together so they can be shown on one
        // line such as "prawnsalad sets +b on nick1, nick2"
        (0, _forEach.default)(_context19 = event.modes).call(_context19, function (mode) {
          _modeStrs[mode.mode] = _modeStrs[mode.mode] || []; // If this mode has a user prefix then we need to update the user object

          var prefix = (0, _find.default)(_lodash.default).call(_lodash.default, network.ircClient.network.options.PREFIX, {
            mode: mode.mode[1]
          });

          if (prefix) {
            var user = state.getUser(network.id, mode.param);

            if (user) {
              var adding = mode.mode[0] === '+';
              var modes = user.buffers[_buffer14.id].modes;
              var modeIdx = (0, _indexOf.default)(modes).call(modes, prefix.mode); // Add or remove the mode from the users mode list

              if (adding && modeIdx === -1) {
                modes.push(prefix.mode);
              } else if (!adding && modeIdx > -1) {
                (0, _splice.default)(modes).call(modes, modeIdx, 1);
              }
            }

            _modeStrs[mode.mode].push({
              target: mode.param
            });
          } else {
            // Not a user prefix, add it as a channel mode
            // TODO: Why are these not appearing as the 'channel info' command?
            var _adding = mode.mode[0] === '+';

            var modeChar = mode.mode.substr(1);

            if (_adding) {
              state.$set(_buffer14.modes, modeChar, mode.param);
            } else if (!_adding) {
              state.$delete(_buffer14.modes, modeChar);
            }

            _modeStrs[mode.mode].push({
              target: _buffer14.name,
              param: mode.param
            });
          }
        }); // Mode -> locale ID mappings
        // If a mode isn't found here, the local ID modes_other is used

        var modeLocaleIds = {
          '+o': 'modes_give_ops',
          '-o': 'modes_take_ops',
          '+h': 'modes_give_halfops',
          '-h': 'modes_take_halfops',
          '+v': 'modes_give_voice',
          '-v': 'modes_take_voice',
          '+a': 'modes_give_admin',
          '-a': 'modes_take_admin',
          '+q': 'modes_give_owner',
          '-q': 'modes_take_owner',
          '+b': 'modes_gives_ban',
          '-b': 'modes_takes_ban'
        }; // Some IRCd differences

        if (!IrcdDiffs.isQChannelModeOwner(network)) {
          delete modeLocaleIds['+q'];
          delete modeLocaleIds['-q'];
        }

        if (!IrcdDiffs.isAChannelModeAdmin(network)) {
          delete modeLocaleIds['+a'];
          delete modeLocaleIds['-a'];
        }

        if (!IrcdDiffs.supportsHalfOp(network)) {
          delete modeLocaleIds['+h'];
          delete modeLocaleIds['-h'];
        } // Some modes have specific data for its locale data while most
        // use a default. The returned objects are passed to the translation
        // functions to build the translation


        var modeLocaleDataBuilders = {
          default: function _default(targets, mode) {
            return {
              mode: mode + (targets[0].param ? ' ' + targets[0].param : ''),
              target: (0, _map.default)(targets).call(targets, function (t) {
                return t.target;
              }).join(', '),
              nick: event.nick
            };
          },
          b: function b(targets, mode) {
            return {
              mode: mode,
              target: targets[0].param ? targets[0].param : '',
              nick: event.nick
            };
          }
        }; // Show one line per mode, listing each effecting user

        _lodash.default.each(_modeStrs, function (targets, mode) {
          // Find a locale data builder for this mode
          var builders = modeLocaleDataBuilders;
          var localeDataFn = builders[mode[1]] || builders.default;
          var localeData = localeDataFn(targets, mode); // Translate using the built locale data

          var localeKey = modeLocaleIds[mode] || 'modes_other';
          var text = TextFormatting.t(localeKey, localeData);
          var messageBody = TextFormatting.formatText('mode', {
            nick: event.nick,
            username: event.ident,
            host: event.hostname,
            target: (0, _map.default)(targets).call(targets, function (t) {
              return t.target;
            }).join(', '),
            text: text
          });
          state.addMessage(_buffer14, {
            time: eventTime,
            server_time: serverTime,
            nick: '',
            message: messageBody,
            type: 'mode'
          });
        });
      } else {
        var _context20;

        // target is not a channel buffer (user mode ?)
        // if mode had param, show in a new line
        var modeslines = {}; // Group each - or + modes to each of their own message lines

        (0, _forEach.default)(_context20 = event.modes).call(_context20, function (mode) {
          if (mode.param) {
            modeslines[mode.mode] = ' ' + mode.param;
          } else if (mode.mode[0] === '-') {
            var _context21;

            if (!modeslines['-']) {
              modeslines['-'] = '';
            }

            modeslines['-'] += (0, _slice.default)(_context21 = mode.mode).call(_context21, 1);
          } else {
            if (!modeslines['+']) {
              modeslines['+'] = '';
            }

            if (mode.mode[0] === '+') {
              var _context22;

              modeslines['+'] += (0, _slice.default)(_context22 = mode.mode).call(_context22, 1);
            } else {
              modeslines['+'] += mode.mode;
            }
          }
        });

        var _serverBuffer = network.serverBuffer();

        _lodash.default.each(modeslines, function (mode, value) {
          var text = TextFormatting.t('modes_other', {
            nick: event.nick,
            target: event.target,
            mode: value + mode
          });
          var messageBody = TextFormatting.formatText('mode', {
            nick: event.nick,
            username: event.ident,
            host: event.hostname,
            target: event.target,
            text: text
          });
          state.addMessage(_serverBuffer, {
            time: (0, _now.default)(),
            nick: '',
            message: messageBody,
            type: 'mode'
          });
        });
      }
    }

    if (command === 'banlist') {
      var _buffer15 = state.getBufferByName(networkid, event.channel);

      if (_buffer15 && (0, _flags.default)(_buffer15).requested_banlist) {
        if (!event.bans || event.bans.length === 0) {
          state.addMessage(_buffer15, {
            time: eventTime,
            server_time: serverTime,
            nick: '',
            message: TextFormatting.t('bans_nobody'),
            type: 'banlist'
          });
        } else {
          var banText = '';

          _lodash.default.each(event.bans, function (ban) {
            var _context23, _context24;

            var dateStr = new Date(ban.banned_at * 1000).toDateString();
            banText += (0, _concat.default)(_context23 = (0, _concat.default)(_context24 = "+b ".concat(ban.banned, " [by ")).call(_context24, ban.banned_by, ", ")).call(_context23, dateStr, "]\n");
          });

          state.addMessage(_buffer15, {
            time: eventTime,
            server_time: serverTime,
            nick: '*',
            message: banText,
            type: 'banlist'
          });
        }

        (0, _flags.default)(_buffer15).requested_banlist = false;
      }
    }

    if (command === 'topic') {
      var _context25;

      var _buffer16 = state.getOrAddBufferByName(networkid, event.channel);

      _buffer16.topic = event.topic || '';
      var _messageBody8 = '';

      if (event.nick) {
        _messageBody8 = TextFormatting.formatAndT('channel_topic', null, 'changed_topic_to', {
          nick: event.nick,
          topic: event.topic
        });
      } else if ((0, _trim.default)(_context25 = _buffer16.topic).call(_context25)) {
        _messageBody8 = TextFormatting.formatText('channel_topic', _buffer16.topic);
      }

      if (_messageBody8) {
        state.addMessage(_buffer16, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody8,
          type: 'topic'
        });
      }
    }

    if (command === 'ctcp response' || command === 'ctcp request') {
      var _buffer17 = network.bufferByName(event.target) || network.serverBuffer();

      var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';

      var _messageBody9 = TextFormatting.formatText(textFormatId, {
        nick: event.nick,
        message: event.message,
        type: event.type
      });

      state.addMessage(_buffer17, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody9,
        type: 'error'
      });

      if (command === 'ctcp request' && event.type === 'VERSION') {
        client.ctcpResponse(event.nick, 'VERSION', 'Kiwi IRC');
      }
    }

    if (command === 'nick invalid') {
      var _messageBody10 = TextFormatting.formatText('general_error', {
        text: event.reason
      });

      var _buffer18 = state.getActiveBuffer();

      state.addMessage(_buffer18, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody10,
        type: 'error'
      });

      if (!isRegistered) {
        network.last_error_numeric = 432;
        network.last_error = event.reason;
        network.ircClient.quit();
      }
    }

    if (command === 'irc error') {
      var _buffer19;

      if (event.channel || event.nick) {
        _buffer19 = state.getOrAddBufferByName(network.id, event.channel || event.nick);
      }

      if (!_buffer19) {
        _buffer19 = network.serverBuffer();
      }

      if (!_buffer19) {
        // we could not find a buffer, this is likely because the network was removed
        return;
      } // TODO: Some of these errors contain a .error property whcih we can match against,
      // ie. password_mismatch.


      if (event.error === 'bad_channel_key') {
        (0, _flags.default)(_buffer19).channel_badkey = true;
      } // ignore error 432 (erroneous nickname) as it is handled above


      if (event.reason && network.last_error_numeric !== 432) {
        if (!isRegistered) {
          network.last_error = event.reason;
        }

        var _messageBody11 = TextFormatting.formatText('general_error', {
          text: event.reason || event.error
        });

        state.addMessage(_buffer19, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody11,
          type: 'error'
        });
      } // Getting an error about a channel while we are not joined means that we couldn't join
      // or do some action on it. Disable it until we manually reattempt to join.


      if (_buffer19.isChannel() && !_buffer19.joined) {
        _buffer19.enabled = false;
      }
    }

    next();
  }
}

function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IrcClient"]
window._kiwi_exports.libs.IrcClient = exports.default ? exports.default : exports;
